import { ExchangeActions } from './exchange.action';
import { InitializerAction } from '../initializer/initiliazer.action';

export class ExchangeState {
    orders: any;
    issuer: any;
    pending: boolean;
    error: null;
    closingStrategyPending: boolean;
    cancelingOrderPending: boolean;
    cancelingStrategyPending: boolean;
    tradingTime: {
        limitDayTradeStock: string | Date,
        limitDayTradeOption: string | Date,
        limitDayTradeFuture: string | Date,
        openingBovespa: string | Date,
        openingFuture: string | Date,
        closingBovespa: string | Date,
        closingFuture: string | Date
    }
}

export const initialGenericState: ExchangeState = {
    orders: '',
    issuer: '',
    pending: false,
    error: null,
    closingStrategyPending: false,
    cancelingOrderPending: false,
    cancelingStrategyPending: false,
    tradingTime: null
}

export function ExchangeReducer(state: ExchangeState = initialGenericState, action: any){

    switch (action.type) {

        case ExchangeActions.getClientOrders:
            return {...state, ...{ pending: true, error: null } };
        case ExchangeActions.getClientOrdersSuccess:
            return {...state, ...{ pending: false, error: null, orders: action.payload } };
        case ExchangeActions.getClientOrdersError:
            return {...state, ...{ pending: false, error: action.payload } };

        case ExchangeActions.closeStrategy:
            return {...state, ...{closingStrategyPending: true, error: null}};
        case ExchangeActions.closeStrategySuccess:
            return {...state, ...{closingStrategyPending: false, error: null}};
        case ExchangeActions.closeStrategyError:
            return {...state, ...{closingStrategyPending: false, error: action.payload}};

        case ExchangeActions.cancelOrder:
            return {...state, ...{cancelingOrderPending: true, error: null}};
        case ExchangeActions.cancelOrderSuccess:
            return {...state, ...{cancelingOrderPending: false, error: null}};
        case ExchangeActions.cancelOrderError:
            return {...state, ...{cancelingOrderPending: false, error: action.payload}};

        case ExchangeActions.cancelStrategy:
            return {...state, ...{cancelingStrategyPending: true, error: null}};
        case ExchangeActions.cancelStrategySuccess:
            return {...state, ...{cancelingStrategyPending: false, error: null}};
        case ExchangeActions.cancelStrategyError:
            return {...state, ...{cancelingStrategyPending: false, error: action.payload}};

        case ExchangeActions.getTradingTime:
            return {...state, ...{ pending: true, error: null } };
        case ExchangeActions.getTradingTimeSuccess:
            return {...state, ...{ pending: false, error: null, tradingTime: action.payload } };
        case ExchangeActions.getTradingTimeError:
            return {...state, ...{ pending: false, error: action.payload } };

        case InitializerAction.resetUserRelatedData:
            return {...state, ...{orders: initialGenericState.orders, tradingTime: initialGenericState.tradingTime}};

        default:
            return state;
    }

}
